export default "__VITE_ASSET__U2_V8Qqc__"